<template>
    <div class="tree_classificator_container">
        <div class="class_tree class_row">
            <table class="big_class_table">
                <colgroup>
                    <col style="width: 34%" />
                    <col style="width: 33%" />
                    <col style="width: 33%" />
                </colgroup>
                <tr>
                    <td>Cuenta</td>
                    <td>{{ localTypes[0] == 'VACIO' ? '' : smartCapitalize(localTypes[0]) }}</td>
                    <td>{{ localTypes[1] == 'NADA' ? '' : smartCapitalize(localTypes[1]) }}</td>
                </tr>
                <tr v-for="(subattr, index) in selectedAccounts" v-bind:key="subattr.id">
                    <td v-if="hasGrandParent(subattr)" :rowspan="calcRowspan(subattr.parentAttr.parentAccount)"
                        class="box_container first_third">
                        <ClassificationBox :account="subattr.parentAttr.parentAccount.account" theme="third_box_1"
                            :style="{ height: calcRowspanHeight(subattr.parentAttr.parentAccount) + 'px' }"
                            :options="internalAccounts" :money="subattr.parentAttr.parentAccount.money"
                            :hasSearchBox="true"
                            :percentage="subattr.parentAttr.parentAccount.percentage" :isDisabledPercentage="index == 0"
                            :isAccount="true" @update-selection="updateParentAccount(subattr, $event, index)"
                            @update-selection-percentage="updateParentAccountPercentage(subattr.parentAttr.parentAccount, $event)" />
                        <div class="rrow">
                            <b-button
                                :class="['operation_btn', { 'is-disabled-local': subattr.parentAttr.parentAccount.account < 0 }]"
                                @click="() => addAccount()">
                                + Agregar
                            </b-button>
                            <b-button class="operation_btn ml-2" @click="() => removeAccount(subattr)">
                                - Quitar
                            </b-button>
                        </div>
                    </td>
                    <td v-if="hasParent(subattr) && localTypes[0] != 'VACIO'" :rowspan="calcRowspan(subattr.parentAttr)"
                        :class="['box_container', 'second_third', { 'is-disabled-local': subattr.parentAttr.parentAccount.account < 0 }]">
                        <ClassificationBox :account="subattr.parentAttr.classified_attribute" theme="third_box_2"
                            :style="{ height: calcRowspanHeight(subattr.parentAttr) + 'px' }"
                            :options="specificAllAttributes[localTypes[0]]" :money="subattr.parentAttr.money"
                            :percentage="subattr.parentAttr.percentage" :hasSearchBox="true"
                            :isDisabledPercentage="isFirstChild(subattr, 'parentAccount')"
                            @update-selection="updateAttribute(subattr, $event)"
                            @update-selection-percentage="updateAttributePercentage(subattr, $event)" />
                        <div class="rrow">
                            <b-button
                                :class="['operation_btn', { 'is-disabled-local': !subattr.parentAttr.classified_attribute || subattr.parentAttr.classified_attribute < 0 }]"
                                @click="() => addAttribute(subattr, index + calcRowspan(subattr.parentAttr))">
                                + Agregar
                            </b-button>
                            <b-button class="operation_btn ml-2" @click="() => removeAttribute(subattr, index)">
                                - Quitar
                            </b-button>
                        </div>
                    </td>
                    <td :class="['box_container', 'third_third',
                        { 'is-disabled-local': !subattr.parentAttr.classified_attribute || subattr.parentAttr.classified_attribute < 0 }]"
                        v-if="localTypes[1] != 'NADA'">
                        <ClassificationBox :account="subattr.classified_attribute" theme="third_box_3"
                            :options="specificAllAttributes[localTypes[1]]" :money="subattr.money"
                            :hasSearchBox="true"
                            :percentage="subattr.percentage" :isDisabledPercentage="isFirstChild(subattr, 'parentAttr')"
                            @update-selection="updateSubAttribute(subattr, $event)"
                            @update-selection-percentage="updateSubAttributePercentage(subattr, $event)" />
                        <div class="rrow">
                            <b-button
                                :class="['operation_btn', { 'is-disabled-local': !subattr.classified_attribute || subattr.classified_attribute < 0 }]"
                                @click="() => addSubAttribute(subattr, index)">
                                + Agregar
                            </b-button>
                            <b-button class="operation_btn ml-2" @click="() => removeSubAttribute(subattr, index)">
                                - Quitar
                            </b-button>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="class_footer class_row">
            <b-button class="clasificar_contraparte_button" :disabled="!isValidInputs" @click="() => saveTree()">
                <span v-if="documentsIds && documentsIds.length > 0">Clasificar por Documento</span>
                <span v-else>Clasificar por Contraparte</span>
            </b-button>
            <b-button :disabled="!isNotEmptyTree" class="reset_tree_button ml-2" @click="() => resetProrates()">
                <span>Reiniciar</span>
            </b-button>
            <b-button v-if="documentsIds && documentsIds.length > 0" class="close_contraparte_button ml-2"
                @click="() => $emit('close-tree')">
                <span>Cerrar</span>
            </b-button>
            <span v-if="showMsgSuccess" class="is-pulled-right msg-success-save-tree">
                <Tick class="icon mr-2" />
                Clasificación por contraparte configurada con éxito
                <Ecs class="icon close-icon" @click="() => showMsgSuccess = false" />
            </span>
            <span v-if="isInitialEdited && !isValidTree" class="ml-1 is-pulled-right accrualError">
                <p class="text is-flex is-align-items-stretch">
                    <ExclamationAlert class="" />
                    <span class="ml-2"> Clasificación incorrecta, selecciona una cuenta valida </span>
                </p>
            </span>
            <!-- <span v-if="isInitialEdited && isTreeEqualToInitial" class="is-pulled-right accrualError">
                <p class="text is-flex is-align-items-stretch">
                    <ExclamationAlert class="" />
                    <span class="ml-2"> Ningún cambio a realizar</span>
                </p>
            </span> -->
        </div>
    </div>
</template>

<script>
import ClassificationBox from "@/components/classification/ClassificationBox";
import Ecs from "@/components/svg/Ecs";
import ExclamationAlert from "@/components/svg/ExclamationAlert";
import Tick from "@/components/svg/Tick";
import { consoleHandlerError, notificate } from "@/utils/message";
import { redistributePercents } from "@/utils/proratePercents";
import { smartCapitalize } from "@/utils/string";
import {
    emptyAttribute,
    emptySubAttribute,
    emptySubAttrLine,
    createEmptyAttr,
    calculateAllAmountsTree,
} from "@/utils/treeProrate";
import { mapActions } from "vuex";


export default {
    name: "TreeClassificator",
    components: {
        ClassificationBox,
        Ecs,
        Tick,
        ExclamationAlert
    },
    data() {
        return {
            loading: null,
            selectedRange: "",
            listRender: [],
            entries: [],
            total: 0,
            isSaveDisabled: false,
            internalAccounts: [],
            selectedAccounts: [],
            initialSelectedAccounts: [],
            specificAllAttributes: [],
            specificProratesXAttribute: [],
            localMoney: 0,
            showMsgSuccess: false,
            isInitialEdited: false,
            msgPercentageInvalid: '',
            localTypes: [],
            isResettingDocument: false,
            // IDs de los setTimeout pendientes (mensajes de éxito + animación de
            // cierre). Se cancelan en beforeDestroy: el componente se monta en
            // una fila expandible / drawer que puede colapsar antes de que el
            // timer dispare, y el callback emite reloadDocs/close sobre una
            // instancia ya destruida.
            pendingTimers: [],
        };
    },
    methods: {
        smartCapitalize,
        ...mapActions("classification", [
            "saveProrateTree",
            "deleteProrateByCompanyInvolved",
        ]),
        // Programa un setTimeout rastreado para que beforeDestroy lo cancele.
        // El id se auto-remueve de la lista cuando el callback corre.
        scheduleTimer(fn, ms) {
            const id = setTimeout(() => {
                this.pendingTimers = this.pendingTimers.filter((t) => t !== id);
                fn();
            }, ms);
            this.pendingTimers.push(id);
            return id;
        },
        calculateAllPercentsAccount(usedAccount, calculatePercentage) {
            let allAccounts = {}
            this.selectedAccounts.map((selectedAccount, iSelectedAccount) => {
                const keyAccount = selectedAccount.parentAttr.parentAccount.fakeId
                if (!(keyAccount in allAccounts)) {
                    allAccounts[keyAccount] = { ...selectedAccount.parentAttr.parentAccount }
                    allAccounts[keyAccount].order = iSelectedAccount
                }
            })

            let orderedAccounts = []
            Object.keys(allAccounts).forEach(function (key) {
                orderedAccounts[allAccounts[key].order] = { ...allAccounts[key] }
            });

            // Reparte el 100% (base 1000) entre las cuentas; ver redistributePercents.
            redistributePercents(orderedAccounts, usedAccount.fakeId, calculatePercentage)

            this.selectedAccounts = this.selectedAccounts.map((selectedAccount) => {
                const keyAccount = selectedAccount.parentAttr.parentAccount.fakeId
                const accountUpdated = orderedAccounts.filter(oAccount => oAccount.fakeId == keyAccount)
                selectedAccount.parentAttr.parentAccount.percentage = accountUpdated[0].percentage / 10
                return selectedAccount
            })
            const subAttributes = [...this.selectedAccounts];
            this.selectedAccounts = this.fixVisibility(subAttributes);
        },
        updateParentAccount(subattr, eventValue, index) {
            this.isInitialEdited = true
            this.selectedAccounts[index].parentAttr.parentAccount.account = eventValue;
            this.calculateAllPercentsAccount({ ...this.selectedAccounts[index].parentAttr.parentAccount }, true)
        },
        updateParentAccountPercentage(account, eventValue) {
            account.percentage = eventValue;
            this.calculateAllPercentsAccount({ ...account }, false)
        },

        calculateAllPercentsAttribute(usedAttribute, calculatePercentage) {
            let allAttributes = {}
            this.selectedAccounts.map((selectedAccount, iSelectedAccount) => {
                const keyAccount = selectedAccount.parentAttr.parentAccount.fakeId
                const keyAttributed = selectedAccount.parentAttr.fakeId
                if (keyAccount == usedAttribute.parentAccount.fakeId && !(keyAttributed in allAttributes)) {
                    allAttributes[keyAttributed] = { ...selectedAccount.parentAttr }
                    allAttributes[keyAttributed].order = iSelectedAccount
                }
            })
            let orderedAttributes = []
            Object.keys(allAttributes).forEach(function (key) {
                orderedAttributes[allAttributes[key].order] = { ...allAttributes[key] }
            });
            // Reparte el 100% (base 1000) entre los atributos; ver redistributePercents.
            redistributePercents(orderedAttributes, usedAttribute.fakeId, calculatePercentage)
            this.selectedAccounts = this.selectedAccounts.map((selectedAccount) => {
                const keyAttrib = selectedAccount.parentAttr.fakeId
                const attribUpdated = orderedAttributes.filter(oAttrib => oAttrib.fakeId == keyAttrib)

                if (attribUpdated && attribUpdated[0]) {
                    selectedAccount.parentAttr.percentage = attribUpdated[0].percentage / 10
                }
                return selectedAccount
            })
            const subAttributes = [...this.selectedAccounts];
            this.selectedAccounts = this.fixVisibility(subAttributes);
        },
        updateAttribute(subattr, eventValue) {
            this.isInitialEdited = true
            subattr.parentAttr.classified_attribute = eventValue;
            this.calculateAllPercentsAttribute({ ...subattr.parentAttr }, true)
        },
        updateAttributePercentage(subattr, eventValue) {
            subattr.parentAttr.percentage = eventValue;
            this.calculateAllPercentsAttribute({ ...subattr.parentAttr }, false)
        },

        calculateAllPercentsSubAttribute(usedSubAttribute, calculatePercentage) {
            let allSubAttributes = {}
            this.selectedAccounts.map((selectedAccount, iSelectedAccount) => {
                const keyAttributed = selectedAccount.parentAttr.fakeId
                const keySubAttributed = selectedAccount.fakeId
                if (keyAttributed == usedSubAttribute.parentAttr.fakeId && !(keySubAttributed in allSubAttributes)) {
                    allSubAttributes[keySubAttributed] = { ...selectedAccount }
                    allSubAttributes[keySubAttributed].order = iSelectedAccount
                }
            })

            let orderedSubAttributes = []
            Object.keys(allSubAttributes).forEach(function (key) {
                orderedSubAttributes[allSubAttributes[key].order] = { ...allSubAttributes[key] }
            });
            // Reparte el 100% (base 1000) entre los subatributos; ver redistributePercents.
            redistributePercents(orderedSubAttributes, usedSubAttribute.fakeId, calculatePercentage)
            this.selectedAccounts = this.selectedAccounts.map((selectedAccount) => {
                const keySubAttrib = selectedAccount.fakeId
                const subAttribUpdated = orderedSubAttributes.filter(oAttrib => oAttrib.fakeId == keySubAttrib)

                if (subAttribUpdated && subAttribUpdated[0]) {
                    selectedAccount.percentage = subAttribUpdated[0].percentage / 10
                }
                return selectedAccount
            })
            if (this.selectedAccounts.length == 1 && !this.selectedAccounts.at(0).classified_attribute) {
                this.selectedAccounts.at(0).percentage = 0
            }
            const subAttributes = [...this.selectedAccounts];
            this.selectedAccounts = this.fixVisibility(subAttributes);
        },
        updateSubAttribute(subattr, eventValue) {
            this.isInitialEdited = true
            subattr.classified_attribute = eventValue;
            this.calculateAllPercentsSubAttribute({ ...subattr }, true)
        },
        updateSubAttributePercentage(subattr, eventValue) {
            subattr.percentage = eventValue;
            this.calculateAllPercentsSubAttribute({ ...subattr }, false)
        },
        calculateAllAmountsTree(subAttrib) {
            return calculateAllAmountsTree(subAttrib, this.localMoney);
        },
        saveTree() {
            const params = {
                // Id de CompaniesInvolved (la contraparte que se clasifica);
                // el backend acepta también la key legacy `company_id`.
                company_involved_id: this.contraparteId,
                tree: this.selectedAccounts,
                document_type: this.documentType,
                classification_type: 'counterpart',
                obligation_name: this.obligationName
            };
            if (this.documentsIds) {
                params.classification_type = 'document'
                params.documents_id_selected = this.documentsIds
            }
            this.saveProrateTree(params).then(() => {
                this.isInitialEdited = false
                this.showMsgSuccess = true
                let msgSuccess = 'Se clasificó por Contraparte'
                if (this.documentsIds && this.documentsIds.length > 0) {
                    msgSuccess = 'Se clasificó por Documento'
                }
                notificate(
                    `<strong>Éxito!</strong><br>
                    ${msgSuccess}`,
                    "is-success is-light"
                );
                this.scheduleTimer(() => {
                    this.showMsgSuccess = false

                    this.$emit('reload-docs');
                }, 2000);
                //, response.data['reloaded_rows'])
                this.initialSelectedAccounts = this.fixVisibility(JSON.parse(JSON.stringify(this.selectedAccounts)))
            }).catch(error => {
                consoleHandlerError({ error, empty: false });
            })
        },
        getRandomNegativeInt() {
            return Math.floor(Math.random() * (Number.MIN_SAFE_INTEGER + 1)) - 1;
        },
        calcRowspan(attr) {
            return attr.attrs;
        },
        calcRowspanHeight(attr) {
            return attr.attrs * 112 //+ 8 * (attr.attrs - 1);
        },
        hasGrandParent(subattr) {
            return subattr.grandpaVisible;
        },
        hasParent(subattr) {
            return subattr.paVisible;
        },
        isFirstChild(subAttrib, parentKey) {
            let childs = []
            if (parentKey == 'parentAttr') {
                this.selectedAccounts.map(elem => {
                    if (subAttrib.parentAttr.fakeId == elem.parentAttr.fakeId)
                        childs.push(elem)
                })

                if (childs[0].fakeId == subAttrib.fakeId) {
                    return true
                }
                return false
            } else {
                this.selectedAccounts.map(elem => {
                    if (subAttrib.parentAttr.parentAccount.fakeId == elem.parentAttr.parentAccount.fakeId)
                        childs.push(elem)
                })

                if (childs[0].parentAttr.fakeId == subAttrib.parentAttr.fakeId) {
                    return true
                }
                return false
            }

        },
        // Traspasa el porcentaje del sub-atributo quitado al primer hermano
        // que comparte el mismo padre (por fakeId). Si no queda ningún hermano
        // (el nodo quitado era el único de su rama, o la ruta no existe) no
        // hay a quién traspasar: antes los reduce devolvían undefined y la
        // asignación reventaba (CFO_REMOTO_FRONTEND-6C).
        updateFirstChildParent(subAttrib, keysParent) {
            const walk = (root) => keysParent.reduce((acc, key) => acc && acc[key], root);
            const parent = walk(subAttrib);
            if (!parent) return;
            const firstChild = this.selectedAccounts.find(child => {
                const searchedChild = walk(child);
                return searchedChild && searchedChild.fakeId == parent.fakeId
            })
            if (!firstChild) return;
            const keysChild = keysParent.slice(0, -1)
            const updateChild = keysChild.reduce((acc, key) => acc && acc[key], firstChild);
            const removeChild = keysChild.reduce((acc, key) => acc && acc[key], subAttrib);
            if (!updateChild || !removeChild) return;
            updateChild.percentage = Math.round((updateChild.percentage + removeChild.percentage) * 10) / 10
        },
        removeAttribute(subattr, iSubAttrib) {
            //first check if the element can be removed
            const toRemove = subattr.parentAttr;
            // check if this is the last son of this grandpa
            if (subattr.parentAttr.parentAccount.attrs <= 1) {
                const emptyAttr = this.emptyAttribute(subattr.parentAttr.parentAccount)
                this.selectedAccounts[iSubAttrib] = this.emptySubAttribute(emptyAttr)
            } else {
                //second, remove logically on the realParentXs
                const toRemoveIndexes = [];
                for (var ii = this.selectedAccounts.length - 1; ii > 0; ii--) {
                    const elem = this.selectedAccounts[ii];
                    if (elem.parentAttr.id == toRemove.id) {
                        toRemoveIndexes.push(ii);
                    }
                }
                toRemoveIndexes.forEach(index => {
                    this.selectedAccounts.splice(index, 1);
                });
            }

            //finally, we fix the tree
            const subAttributes = [...this.selectedAccounts];
            this.selectedAccounts = this.fixVisibility(subAttributes);
            this.updateFirstChildParent(subattr, ['parentAttr', 'parentAccount'])
            this.updateFirstChildParent(subattr, ['parentAttr'])
        },
        removeSubAttribute(subattr, index) {
            const updatedAccounts = [...this.selectedAccounts];
            if (subattr.parentAttr.attrs > 1) {
                updatedAccounts.splice(index, 1);
            } else {
                // return
                updatedAccounts[index] = this.emptySubAttribute(updatedAccounts.at(index).parentAttr)
            }
            this.selectedAccounts = this.fixVisibility(updatedAccounts);
            this.updateFirstChildParent(subattr, ['parentAttr'])
        },
        addSubAttribute(subattr, index) {
            const newSubattr = this.emptySubAttribute(subattr.parentAttr);
            const updatedAccounts = [...this.selectedAccounts];
            updatedAccounts.splice(index + 1, 0, newSubattr);
            this.selectedAccounts = this.fixVisibility(updatedAccounts);
        },
        addAttribute(subattr, index) {
            const grandpa = subattr.parentAttr.parentAccount;
            const pa = this.emptyAttribute(grandpa);
            const newSubattr = this.emptySubAttribute(pa);
            const updatedTree = [...this.selectedAccounts];
            updatedTree.splice(index, 0, newSubattr);
            this.selectedAccounts = this.fixVisibility(updatedTree);
        },
        removeAccount(subattr) {
            const toRemove = subattr.parentAttr.parentAccount;
            //check if this is the last account
            const accounts = new Set();
            const subattrToRemove = [];
            const updatedAccounts = [...this.selectedAccounts];
            for (var ii = updatedAccounts.length - 1; ii >= 0; ii--) {
                const sa = updatedAccounts[ii];
                accounts.add(sa.parentAttr.parentAccount.id);
                if (sa.parentAttr.parentAccount.id == toRemove.id) {
                    subattrToRemove.push(ii);
                }
            }
            if (accounts.size <= 1) {
                return;
            }
            subattrToRemove.forEach(index => {
                updatedAccounts.splice(index, 1);
            });
            this.selectedAccounts = this.fixVisibility(updatedAccounts);
            this.selectedAccounts[0].parentAttr.parentAccount.percentage = Math.round((this.selectedAccounts[0].parentAttr.parentAccount.percentage + toRemove.percentage) * 10) / 10
        },
        emptySubAttrLine() {
            return emptySubAttrLine(this.getRandomNegativeInt, this.localTypes);
        },
        emptyAttribute(account) {
            return emptyAttribute(account, this.getRandomNegativeInt, this.localTypes);
        },
        emptySubAttribute(attr) {
            return emptySubAttribute(attr, this.getRandomNegativeInt, this.localTypes);
        },
        addAccount() {
            const subattr = this.emptySubAttrLine();
            subattr.paVisible = true;
            subattr.grandpaVisible = true;
            const updatedAccounts = [...this.selectedAccounts];
            updatedAccounts.push(subattr);
            this.selectedAccounts = this.fixVisibility(updatedAccounts);
        },
        selectRow(row, index) {
            this.listRender[index]['selected'] = !row['selected'];
            this.listRender = [...this.listRender];
            this.prorrateEqually();
        },
        deleteProrateEntry() {
        },
        closeModal() {
            const modal = document.querySelector('.drawer_opener');
            if (modal) {
                modal.classList.remove('drawer_animation');
                modal.classList.remove('drawer_closed');
                this.scheduleTimer(() => {
                    this.$emit('close');
                }, 350);
            } else {
                this.$emit('close');
            }
        },
        fillTypes() {
            if (this.localTypes == null || this.localTypes.length < 1) {
                this.localTypes = ['VACIO', 'NADA'];
            } else if (this.localTypes.length < 2) {
                this.localTypes.push('NADA');
            }

            if (this.specificProratesXAttribute[this.localTypes[0]].length < 1) {
                for (const ac of this.classifiedAccounts) {
                    const attr = this.emptyAttribute(null);
                    attr.parent_account = ac.id;
                    this.specificProratesXAttribute[this.localTypes[0]].push(attr);
                }
            }
            if (this.specificProratesXAttribute[this.localTypes[1]].length < 1) {
                for (const attr of this.specificProratesXAttribute[this.localTypes[0]]) {
                    const subattr = this.emptySubAttribute(null);
                    subattr.parent_attr = attr.id;
                    this.specificProratesXAttribute[this.localTypes[1]].push(subattr);
                }
            }

        },
        fixVisibility(subAttributes) {
            for (const sub of subAttributes) {
                if (!sub.fakeId) {
                    sub.fakeId = this.getRandomNegativeInt();
                }
                if (!sub.parentAttr.fakeId) {
                    sub.parentAttr.fakeId = this.getRandomNegativeInt();
                }
                if (!sub.parentAttr.parentAccount.fakeId) {
                    sub.parentAttr.parentAccount.fakeId = this.getRandomNegativeInt();
                }
            }

            var lastGrandpa = null;
            var lastPa = null;
            var sizeAccounts = {};
            var sizeAttributes = {};
            for (const sub of subAttributes) {
                sub.grandpaVisible = false;
                if (lastGrandpa != sub.parentAttr.parentAccount.fakeId) {
                    lastGrandpa = sub.parentAttr.parentAccount.fakeId;
                    sizeAccounts[lastGrandpa] = 0;
                    sub.grandpaVisible = true;
                }
                sizeAccounts[lastGrandpa] += 1;
                sub.paVisible = false;
                if (lastPa != sub.parentAttr.fakeId) {
                    lastPa = sub.parentAttr.fakeId;
                    sizeAttributes[lastPa] = 0;
                    sub.paVisible = true;
                }
                sizeAttributes[lastPa] += 1;
            }
            let newSubAttr = []
            for (const sub of subAttributes) {
                sub.parentAttr.attrs = sizeAttributes[sub.parentAttr.fakeId];
                sub.parentAttr.parentAccount.attrs = sizeAccounts[sub.parentAttr.parentAccount.fakeId];
                newSubAttr.push(this.calculateAllAmountsTree(sub))
            }
            return JSON.parse(JSON.stringify(newSubAttr));
        },
        createEmptyAttr(type, account, attr) {
            return createEmptyAttr(type, account, attr, this.getRandomNegativeInt);
        },
        fixChildlessAccounts() {
            //first, calc the childless accounts
            const accountIds = new Set();
            for (const account of this.classifiedAccounts) {
                accountIds.add(account.id); //so we add accounts....
            }
            for (const attr of this.specificProratesXAttribute[this.localTypes[0]]) {
                accountIds.delete(attr.parent_account); //and then we delete accounts...
            }
            //if any account was remaining...we create an empty child
            for (const account of accountIds) {
                const emptyattr = this.createEmptyAttr(this.localTypes[0], account, null);
                this.specificProratesXAttribute[this.localTypes[0]].push(emptyattr);
            }
        },
        fixChildlessAttributes() {
            const attrIds = new Set();
            for (const attr of this.specificProratesXAttribute[this.localTypes[0]]) {
                attrIds.add(attr.id);
            }

            for (const subattr of this.specificProratesXAttribute[this.localTypes[1]]) {
                attrIds.delete(subattr.parent_attr);
            }
            //add an emptry subattr for the remaining attrIds
            for (const attrid of attrIds) {
                const emptysubattr = this.createEmptyAttr(this.localTypes[1], null, attrid);
                this.specificProratesXAttribute[this.localTypes[1]].push(emptysubattr);
            }
        },
        initProrates() {
            if (this.localTypes == null || this.localTypes.length < 1) {
                this.localTypes = ['VACIO', 'NADA'];
            } else if (this.localTypes.length < 2) {
                this.localTypes.push('NADA');
            }

            const specific_all_attributes = {};
            const specific_prorates_x_attribute = {};
            for (const type of this.localTypes) {
                const one_specific_type = this.allAttributes.filter(attr => attr.type == type);
                specific_all_attributes[type] = one_specific_type;

                const one_specific_pxa = this.classifiedAttributes.filter(attr => attr.attribute_type == type);
                specific_prorates_x_attribute[type] = one_specific_pxa;
            }
            this.specificAllAttributes = { ...specific_all_attributes }
            this.specificProratesXAttribute = { ...specific_prorates_x_attribute }

        },
        initClassifiedAccounts() {
            if (this.specificProratesXAttribute.length == 0) {
                return
            }
            this.fillTypes();
            const subAttributes = [];
            this.fixChildlessAccounts();
            this.fixChildlessAttributes();

            for (const a1 of this.specificProratesXAttribute[this.localTypes[0]]) {
                a1.attrs = 0;
                for (const a2 of this.specificProratesXAttribute[this.localTypes[1]]) {
                    if (a2.parent_attr == a1.id) {
                        a2.parentAttr = a1;
                        a2.paVisible = a1.attrs < 1;
                        subAttributes.push({ ...a2 });
                    }
                }
            }
            for (const ia of this.classifiedAccounts) {
                ia.attrs = 0;
                for (const a1 of this.specificProratesXAttribute[this.localTypes[0]]) {
                    if (a1.parent_account == ia.id) {
                        a1.parentAccount = ia;

                    }
                }
            }
            if (subAttributes.length == 0)
                this.selectedAccounts = this.fixVisibility([this.emptySubAttrLine()]);
            else
                this.selectedAccounts = this.fixVisibility(subAttributes);
        },
        resetProrates() {
            const params = {
                idCompanyInvolved: this.contraparteId,
                documentType: this.documentType,
                obligation_name: this.obligationName
            };
            if (this.documentsIds) {
                params.documentsIds = this.documentsIds
            }
            this.deleteProrateByCompanyInvolved(params).then(() => {
                this.isInitialEdited = false
                this.showMsgSuccess = true
                let msgSuccess = 'Se reinicio la clasificación por Contraparte'
                if (this.documentsIds && this.documentsIds.length > 0) {
                    msgSuccess = 'Se reinicio la clasificación por Documento'
                }
                notificate(
                    `<strong>Éxito!</strong><br>
                    ${msgSuccess}`,
                    "is-success is-light"
                );
                this.scheduleTimer(() => {
                    this.showMsgSuccess = false
                    this.$emit('reload-docs');
                }, 1500);

                this.selectedAccounts = this.fixVisibility([this.emptySubAttrLine()]);
            }).catch(error => {
                consoleHandlerError({ error, empty: false });
            })
        }
    },
    computed: {
        isNotEmptyTree() {
            let hasContent = false
            if (this.selectedAccounts.length == 1) {
                hasContent = this.selectedAccounts[0].classified_attribute >= 0 ||
                    this.selectedAccounts[0].parentAttr.classified_attribute >= 0 ||
                    this.selectedAccounts[0].parentAttr.parentAccount.account >= 0
            }
            return hasContent
        },
        isValidTree() {
            let isValid = true
            this.selectedAccounts.map(subAttrib => {
                if (subAttrib.parentAttr.parentAccount.account < 0 ||
                    subAttrib.parentAttr.parentAccount.percentage <= 0) {
                    isValid = false
                }
                if (subAttrib.parentAttr.classified_attribute > 0 &&
                    subAttrib.parentAttr.percentage <= 0) {
                    isValid = false
                }
                if (subAttrib.classified_attribute > 0 &&
                    subAttrib.percentage <= 0) {
                    isValid = false
                }
            })
            return isValid
        },
        isTreeEqualToInitial() {
            let isEqual = true
            if (this.selectedAccounts.length != this.initialSelectedAccounts.length) {
                return false
            }

            this.selectedAccounts.map((subAttrib, iSubAttrib) => {
                if (subAttrib.parentAttr.parentAccount.account != this.initialSelectedAccounts[iSubAttrib].parentAttr.parentAccount.account ||
                    subAttrib.parentAttr.classified_attribute != this.initialSelectedAccounts[iSubAttrib].parentAttr.classified_attribute ||
                    subAttrib.classified_attribute != this.initialSelectedAccounts[iSubAttrib].classified_attribute
                ) {
                    isEqual = false
                }
                if (subAttrib.parentAttr.parentAccount.percentage != this.initialSelectedAccounts[iSubAttrib].parentAttr.parentAccount.percentage ||
                    subAttrib.parentAttr.percentage != this.initialSelectedAccounts[iSubAttrib].parentAttr.percentage ||
                    subAttrib.percentage != this.initialSelectedAccounts[iSubAttrib].percentage
                ) {
                    isEqual = false
                }
            })
            return isEqual
        },
        isValidInputs() {
            return this.isValidTree && !this.isTreeEqualToInitial
        },
    },
    mounted() {
        this.localTypes = JSON.parse(JSON.stringify(this.types))
        this.selectedAccounts = this.fixVisibility([this.emptySubAttrLine()]);
        this.internalAccounts = [...this.accounts];
        this.localMoney = this.money
        this.initProrates()
        this.initClassifiedAccounts()
        this.initialSelectedAccounts = this.fixVisibility(JSON.parse(JSON.stringify(this.selectedAccounts)))
    },
    beforeDestroy() {
        // Cancela los timers de feedback/cierre pendientes — sin esto el
        // callback emite reloadDocs/close sobre una instancia ya desmontada
        // si el usuario colapsa la fila o cierra el drawer dentro de la
        // ventana del timer (350ms–2s).
        this.pendingTimers.forEach(clearTimeout);
        this.pendingTimers = [];
    },
    watch: {
        accounts: {
            handler: function (newAccounts) {
                this.internalAccounts = [...newAccounts];
            }
        },
        classifiedAttributes: {
            handler: function () {
                this.initProrates()
                this.initClassifiedAccounts()
                this.initialSelectedAccounts = this.fixVisibility(JSON.parse(JSON.stringify(this.selectedAccounts)))
            }
        },
        money(newMoney) {
            this.localMoney = newMoney
            this.selectedAccounts = this.fixVisibility([...this.selectedAccounts]);
        },
        types(newTypes) {
            this.localTypes = JSON.parse(JSON.stringify(newTypes))
        },
    },
    props: {
        titleModal: String,
        subtitleModal: String,
        contraparteId: Number,
        documentType: String,
        categoryType: String,
        documentsIds: Array,
        documentIdSelected: Number,
        current_period: Number,
        rangeFromMainScreen: String,
        // `accounts/types/...` declaraban `[]` como tipo — inválido: Vue lo lee
        // como lista de constructores permitidos (vacía → nada valida) y deja
        // `this.x` en undefined si el caller la omite, lo que rompía el
        // JSON.parse(JSON.stringify(this.types)) de mounted(). Forma correcta
        // con default factory.
        accounts: { type: Array, default: () => [] },
        classifiedAccounts: { type: Array, default: () => [] },
        types: { type: Array, default: () => [] },
        classifiedAttributes: { type: Array, default: () => [] },
        allAttributes: { type: Array, default: () => [] },
        money: Number,
        obligationName: String,
    }
};
</script>

<style lang="scss" scoped>

.tree_classificator_container {
    display: flex;
    flex-direction: column;
}

.class_row {
    flex: 1;
}

.big_class_table {
    width: 100%;
}

.class_footer {
    margin-top: 16px;
    border-top: 1px solid #eaecf0;
    padding-top: 20px;
    background-color: white;
}

.clasificar_contraparte_button {
    border-radius: 8px;
    background-color: #00a9ad;
    color: white;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    border: 1px solid #00A9AD;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
}

.clasificar_contraparte_button:disabled {
    background-color: #F9FAFB !important;
    color: #98A2B3 !important;
    border: 1px solid #EAECF0;
    opacity: 1;

}

.clasificar_contraparte_button:hover {
    background-color: #057c80;
    color: white;
}


.clasificar_contraparte_button:active {
    background-color: #0a6165;
    color: white;
}

.close_contraparte_button {
    border-radius: 8px;
    padding: 10px 14px;
    border: 1px solid #EAECF0;
    background-color: #FFF;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    color: #475467;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}

.reset_tree_button {
    border-radius: 8px;
    padding: 10px 14px;
    border: 1px solid #EAECF0;
    background-color: rgb(226, 95, 81);
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    color: white;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}

.close_contraparte_button:hover {
    background-color: #d9d4d4;
}

.close_contraparte_button:active {
    background-color: #f3e7e7;
}

.msg-success-save-tree {
    padding: 8px;
    border-radius: 12px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: #ECFDF3;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    color: #079455;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;

    .icon {
        margin-bottom: -5px;
    }

    .close-icon {
        height: 20px;
        width: 20px;
        filter: brightness(0) saturate(100%) invert(65%) sepia(6%) saturate(705%) hue-rotate(179deg) brightness(98%) contrast(93%);
    }
}

.accrualError {
    padding: 8px;
    border-radius: 12px;
    border: 1px solid #FEC84B;
    background: #FFFAEB;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    .text {
        color: #4E1D09;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }
}

.class_tree {
    display: flex;
    flex-direction: row;
}

.tree_container {
    display: flex;
    flex-direction: column;
}

.third {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.third_title {
    flex: 0.3;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    font-family: Inter, "Open Sans", sans-serif;
    color: #344054;
    text-align: left;
    margin-bottom: 8px;
    height: 16px !important;
}

.first_third {
    padding-right: 10px;
    margin-top: 0px !important;
}

.second_third {
    padding-left: 10px;
    padding-right: 10px;
}

.third_third {
    padding-left: 10px;
}

.rrow {
    display: flex;
    flex-direction: row;
    width: 40%;
    margin-bottom: 8px;
}

.operation_btn {
    flex: 1;
    height: 32px;
    border-radius: 8px;
    padding: 10px 12px 10px 12px;
    background-color: white;
    border: 1px solid #D0D5DD;
    justify-content: center;
    align-items: center;
    gap: 4px;
    color: #475467;
    font-size: 14px;
    font-weight: 500;
}
</style>
